
import { Component, Vue } from 'vue-property-decorator'
import {
  GeolocationContext,
  GeolocationMachineInterpreter,
  GeolocationState,
} from '../machine'

@Component
export default class GeolocationMixin extends Vue {
  geolocationMachine: GeolocationMachineInterpreter
  geolocationContext: GeolocationContext | null = null
  geolocationState: GeolocationState | null = null

  async startGeolocationMachine() {
    const { geolocationContainer } = await import(
      /* webpackChunkName: "geolocation-inversify", webpackMode: "lazy" */ '../inversify.config'
    )
    this.geolocationMachine = geolocationContainer.get('GeolocationMachine')
    this.geolocationMachine
      .onTransition((state) => {
        this.geolocationState = state
        this.geolocationContext = state.context
      })
      .start()
  }

  get isGeolocationFailed() {
    return this.geolocationState?.value === 'error'
  }

  get isGeolocationLoading() {
    return this.geolocationState?.value === 'locating'
  }

  get geolocationError() {
    return this.geolocationContext?.errorStatus
  }
}
